import { useCustomer } from 'gatsby-theme-hem-store/src/hooks/useCustomer';
import { Info } from 'lucide-react';
import React from 'react';
import { shallow } from 'zustand/shallow';

import { Modal } from '@/components/Modal';
import { Money } from '@/components/Money';

type Props = {
  listPrice: number;
};

// only valid component if
// - customer
// - is pro
const ProListPrice: React.FC<Props> = ({ listPrice }): JSX.Element => {
  const { customer, currentProDiscount } = useCustomer(
    (state) => ({
      customer: state.customer,
      currentProDiscount: state.currentProDiscount,
    }),
    shallow,
  );

  if (!customer) {
    return null;
  }

  return (
    <Modal
      trigger={
        <button className="mt-2 flex w-full items-center justify-center gap-2 text-base font-normal leading-none text-black-600 hover:text-black hover:underline md:w-auto md:justify-start">
          List price: <Money amount={listPrice} withDiscount={false} />
          <Info size={14} />
        </button>
      }
      title={`Quote discount: ${currentProDiscount}`}
      content={
        <p className="p-4 text-base text-black-600">
          Your Hem Pro discount is always included in the price when buying
          products online.
        </p>
      }
    />
  );
};

export default ProListPrice;
